import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PSPDFKitContainer = _resolveComponent("PSPDFKitContainer")!

  return (_ctx.blobUrl)
    ? (_openBlock(), _createBlock(_component_PSPDFKitContainer, {
        key: 0,
        pdfFile: _ctx.blobUrl,
        onLoaded: _ctx.handleLoaded,
        onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-close')))
      }, null, 8, ["pdfFile", "onLoaded"]))
    : _createCommentVNode("", true)
}